import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type {
  TPostCompanyUBODocumentParams,
  TPostCompanyUBODocumentResponse,
} from "./postCompanyUBODocument.schema";

export const postCompanyUBODocument = (axios: IAxiosInstance) => {
  return async (
    params: TPostCompanyUBODocumentParams
  ): Promise<TPostCompanyUBODocumentResponse> => {
    const { companyID, ubo_document, first_name, last_name } = params;
    const formData = new FormData();
    formData.append("ubo_document", ubo_document);
    formData.append("first_name", first_name);
    formData.append("last_name", last_name);
    const response = await axios.noRetry.post<
      IApiResponse<TPostCompanyUBODocumentResponse>
    >(`/api/companies/${companyID}/ubo-document`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    const resData = response.data;
    if (resData?.data?.success) {
      return {
        success: true,
        message: resData.data?.message,
      };
    }
    throw new Error("Something went wrong");
  };
};
